import ruspolymet_ru from '../img/ru/ruspolymet.png'
import ruspolymet_en from '../img/en/ruspolymet.png'

import diagram_ru from '../img/ru/diagram.png'
import diagram_es from '../img/es/diagram.png'
import diagram_en from '../img/en/diagram.png'

import track_ru from '../img/ru/track.png'
import track_es from '../img/es/track.png'
import track_en from '../img/en/track.png'

import materials_ru from '../img/ru/materials_ru.png'
import materials_es from '../img/es/materials_es.png'
import materials_en from '../img/en/materials_en.png'

import contacts_ru from '../img/ru/contacts_ru.png'
import contacts_en from '../img/en/contacts_en.png'
import contacts_es from '../img/es/contacts_es.png'

export const local = {
    ru: {
        img_diagram: diagram_ru,
        img_ruspolymet: ruspolymet_ru,
        img_track: track_ru,
        img_materials: materials_ru,
        img_contacts: contacts_ru,

        hardened_ingot:
            "Кованый слиток",
        ingot:
            "Слиток",
        shavings:
            "Стуржка",
        scrap:
            "Лом",
        alloy_type:
            "Выберите сплав",
        product_type:
            "Выбрать вид материала",
        chemichal_composition:
            "Хим.состав, %",
        material_banner:
            "На данной странице вы можете ознакомиться с нашими предложениями купли и продажи материала. " +
            "Для более подробной информации о наличии и другим вопросам - свяжитесь с нами.",
        banner_excerption:
            "Где качество становится стандартом",
        label_header:
            "МЫ РАБОТАЕМ ДЛЯ ВАШЕГО УСПЕХА",
        label_text:
            "«Plezimet Group» - это уникальная компания, " +
            "предоставляющая услуги в области металлургии в Европе и СНГ. " +
            "Многолетний опыт работы в металлургическом секторе и уникальная " +
            "философия компании позволяют нам занимать лидирующие " +
            "позиции в европейском секторе.",
        services:
            "НАШИ ОСНОВНЫЕ НАПРАВЛЕНИЯ",
        ruspolimet:
            "Начиная с ноября 2019 года мы рады сообщить, " +
            "что являемся официальными представителями завода ПАО «РУСПОЛИМЕТ» " +
            "на территории Испании и Франции. " +
            "Благодаря чему, Plezimet Group является уверенным игроком на " +
            "рынке продукции авиационной и судостроительной отрасли.",
        ourhistory_label:
            "НАША ИСТОРИЯ",
        ourhistory:
            "Совершив первую сделку в 1997 году и пройдя с того дня длительный и сложный путь, " +
            "Plezimet Group стал уникальной компанией предоставляющей услуги " +
            "в сфере металлургии и сталеплавления на территории Европы. " +
            "Основным рынком компании являются специальные стали, " +
            "предназначенные для авиационно, судостроительной и нефтезагохимической промышленностей. " +
            "Огромный опыт и любовь к своему делу привело Plezimet Group на лидирующие позиции рынка. ",
        ourvalues:
            "НАШИ ЦЕННОСТИ",
        customer:
            "Клиент",
        customer_discp:
            "Мы ценим каждого нашего клиента",
        environment:
            "Окружающий мир",
        environment_discp:
            "Переработка материала и забота о мире, в котором мы живём",
        technology:
            "Технологии",
        technology_discp:
            "Используем только самые эффективные и новые технологии",
        result:
            "Результат",
        result_discp:
            "Работаем до достижения идеального результата",
        ourvision_label:
            "НАШ ВЗГЛЯД И ФИЛОСОФИЯ",
        ourvision:
            "Plezimet Group позиционирует себя как уникальная компания, предоставляющая на " +
            "рынок металлургии ранее не развитые услуги и взаимоотношения между " +
            "компаниями. Основной ценностью любого металлурга является его знания и опыт. " +
            "Осознавая это, мы, в первую очередь, сконцентрированы на новейших технологиях " +
            "и методах работы, позволяющие развивать металлургическую промышленность. ",
        materials:
            "Материалы",
        contacts:
            "Контакты",
        aboutus:
            "О нас",
        mainpage:
            "Главная",
        contactus:
            "Для связи с нами, достаточно заполнить форму ниже:",
        yrname:
            "Ваше имя: ",
        yrpostbox:
            "Ваша почта: ",
        yrcompany:
            "Компания:",
        yrphone:
            "Телефон: ",
        yrcomment:
            "Ваше сообщение:",
        send:
            "Отправить",
        we_are_here:
            "Нас найти можно тут:",
        map_discp:
            "Нажмите на маркер чтобы открыть полную карту в новой вкладке",
        search:
            "Поиск",
        friends:
        "НАШИ ДРУЗЬЯ",
        fast_feedback:
            "Заказать"
    },
    en: {
        img_diagram: diagram_en,
        img_ruspolymet: ruspolymet_en,
        img_track: track_en,
        img_materials: materials_en,
        img_contacts: contacts_en,

        hardened_ingot:
            "Forged ingot",
        ingot:
            "Ingot",
        shavings:
            "Shavings",
        scrap:
            "Scrap",
        alloy_type:
            "Select alloy",
        product_type:
            "Select product type",
        chemichal_composition:
            "Chemical composition, %",
        material_banner:
            "On this page you can found our offers for purchase and sale of material. For more information" +
            "on availability and other questions, please contact us.",
        banner_excerption:
            "Where quality becomes a standard",
        label_header:
            "WE WORK FOR YOUR SUCCESS",
        label_text:
            "Plezimet Group is a unique company providing metallurgic services in Europe and the " +
            "CIS. Many years of experience in the metallurgical sector and a unique philosophy of the " +
            "company allow us to occupy leading positions in the European sector.",
        services:
            "OUR MAIN SERVICES",
        ruspolimet:
            "From November 2019, we are pleased to announce " +
            "that we are the official representatives of the RUSOLYMET PJSC plant on the territory of " +
            "Spain and France. As a result, the Plezimet Group is a confident player in the aviation " +
            "and shipbuilding industries.",
        ourhistory_label:
            "OUR HISTORY",
        ourhistory:
            "Completing our first transaction in 1997 and since that day, " +
            "having followed a long and difficult path, Plezimet Group has become " +
            "a unique company providing services in the field of metallurgy in Europe. " +
            "The company's main market is special steels manufactured for the aviation, " +
            "shipbuilding and petrochemical industries. Great experience and love for " +
            "our work brought Plezimet Group to the leading market positions.",
        ourvalues:
            "OUR VALUES",
        customer:
            "CUSTOMER",
        customer_discp:
            "We value each of our customers",
        environment:
            "ENVIRONMENT",
        environment_discp:
            "We work for you to live in a better world",
        technology:
            "TECHNOLOGIES",
        technology_discp:
            "We use only the most efficient and new technologies",
        result:
            "RESULT",
        result_discp:
            "We work till we achieve the perfect result",
        ourvision_label:
            "OUR VISION AND PHILOSOPHY",
        ourvision:
            "Plezimet Group position itself as a unique company, " +
            "presenting previously undeveloped services and relationships " +
            "between companies on the metallurgy market. The main value of " +
            "any metallurgist is his knowledge and experience. Realizing this, " +
            "we are primarily focused on the latest technologies and working " +
            "methods that allow us to develop the metallurgical industry.",
        materials:
            "Materials",
        contacts:
            "Contacts",
        aboutus:
            "About us",
        mainpage:
            "Main page",
        contactus:
            "To contact us, just fill out the form below.",
        yrname:
            "Your name: ",
        yrpostbox:
            "Your E-Mail: ",
        yrcompany:
            "Company name:",
        yrphone:
            "Phone: ",
        yrcomment:
            "Message:",
        send:
            "Send",
        we_are_here:
            "You can find us here:",
        map_discp:
            "Click on the marker to open the full map in a new tab",
        search:
            "Search",
        friends:
        "OUR FRIENDS",
        fast_feedback:
            "Order"
    },
    es: {
        img_diagram: diagram_es,
        img_ruspolymet: ruspolymet_en,
        img_track: track_es,
        img_materials: materials_es,
        img_contacts: contacts_es,

        hardened_ingot:
            "Lingote forjado",
        ingot:
            "Lingote",
        shavings:
            "Virutas",
        scrap:
            "Chatarra",
        alloy_type:
            "Elegir aleación",
        product_type:
            "Elegir tipo de material",
        chemichal_composition:
            "Composición química, %",
        material_banner:
            "En esta página puede encontrar nuestras ofertas de compra y venta de material." +
            "Para obtener más información sobre disponibilidad y otras preguntas, contáctenos.",
        banner_excerption:
            "Donde la calidad se convierte en un estándar",
        label_header:
            "NOSOTROS TRABAJAMOS PARA SU ÉXITO",
        label_text:
            "«Plezimet Group» - es una empresa única " +
            "que ofrece servicios metalúrgicos en Europa y la CEI. " +
            "Muchos años de experiencia en el sector metalúrgico y una filosofía " +
            "de la compañía única, nos permiten ocupar posiciones superiores " +
            "en el sector europeo.",
        services:
            "NUESTROS SERVICIOS PRINCIPALES",
        ruspolimet:
            "Desde noviembre de 2019, nos complace anunciar " +
            "que somos los representantes oficiales de la planta RUSOLYMET PJSC " +
            "en el territorio de España y Francia. " +
            "Como resultado, Plezimet Group es un jugador seguro en las industrias " +
            "de aviación y construcción naval.",
        ourhistory_label:
            "NUESTRA HISTORIA",
        ourhistory:
            "Completando nuestra primera transacción en 1997 y desde ese día, después de haber seguido " +
            "un camino largo y difícil, Plezimet Group se ha convertido en una compañía única " +
            "que ofrece servicios en el campo de la metalurgia en Europa." +
            "El mercado principal de la compañía son los aceros especiales " +
            "fabricados para las industrias de aviación, construcción naval y petroquímica. " +
            "La gran experiencia y el amor por nuestro trabajo llevaron Plezimet Group a las primeras posiciones del mercado. ",
        ourvalues:
            "VALORES",
        customer:
            "Cliente",
        customer_discp:
            "Valoramos a cada cliente nuestro",
        environment:
            "Medioambiente",
        environment_discp:
            "Trabajamos para que vivas en un mundo mejor",
        technology:
            "Desarrollo tecnológico",
        technology_discp:
            "Utilizamos solo las tecnologías más eficientes y nuevas",
        result:
            "Resultado",
        result_discp:
            "Trabajamos hasta lograr el resultado perfecto",
        ourvision_label:
            "VISIÓN Y FILOSOFÍA",
        ourvision:
            "Plezimet Group se posiciona como una empresa única, presentando servicios " +
            "y relaciones previamente no desarrolladas entre compañías en el mercado metalúrgico." +
            "El principal valor de cualquier metalúrgico es su conocimiento y experiencia." +
            "Al darnos cuenta de esto, estamos enfocados principalmente en las últimas tecnologías y" +
            "métodos de trabajo que nos permiten desarrollar la industria metalúrgica. ",
        materials:
            "Materiales",
        contacts:
            "Contactos",
        aboutus:
            "Nosotros",
        mainpage:
            "Inicio",
        contactus:
            "Para contactarnos, simplemente complete el formulario a continuación.",
        yrname:
            "Nombre: ",
        yrpostbox:
            "Correo electrónico: ",
        yrcompany:
            "Empresa:",
        yrphone:
            "Telefono: ",
        yrcomment:
            "Mensaje:",
        send:
            "Enviar",
        we_are_here:
            "Oficina central:",
        map_discp:
            "¡Haga clic en el marcador para abrir el mapa completo en una nueva pestaña!",
        search:
            "Buscar",
        friends:
            "NUESTROS AMIGOS",
        fast_feedback:
            "Pedir"
    }
};
